import {Component, OnInit} from '@angular/core';

@Component({
  selector: 'sa-phone-call',
  templateUrl: 'phone-call.component.html',
  styles: [`.vc-title-error {display: block;}`]
})
export class PhoneCallComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }
}
